import React, { useState } from 'react';
import styled from 'styled-components';
import ProjectCard from './ProjectCard';
import ImageGallery from './ImageGallary';
import { SubTitle, Title } from './Title';
import { SectionWrapper } from './SectionWrapper';
import { useAnalytics } from '../context/AnalyticsContext';

const Content = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
  margin: 1rem 0;
`;

const Tabs = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const TabButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 1.6rem;
  margin: 0 10px;
  color: ${({ active }) => (active ? '#444' : '#999')};
  border-bottom: ${({ active }) => (active ? '2px solid #333' : 'none')};
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    color: #333;
    outline: none;
  }
`;

const ProjectList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
  padding: 3rem 0;
`;

// const CertsWrap = styled.div`
//   height: 500px;
//   overflow-x: auto;
// `;
// const Certs = styled.img`
//   height: 156px;
//   width: auto;
//   padding: 0 10px 10px 0;
// `;

const StyledSpan= styled.span`
  /* display: block; */
  @media (max-width: 768px){
    display: none;
  }
`

const ProjectsSection = () => {
  const [activeTab, setActiveTab] = useState("projects");
  const { trackTabClick } = useAnalytics();

  const handleTabChange = (tab) => {
    trackTabClick(tab);
    setActiveTab(tab);
  };
  const projects = [{
    title: 'ExpenseWise',
    description: 'ExpenseWise is a dashboard app designed to help users manage their expenses efficiently. It consists of a backend built with Springboot and a frontend built with React. Authentication, authorization and RBAC are implemented using Spring Security.',
    repoUrl: 'https://github.com/ksachin7/Projects/tree/main/ExpenseWise',
    deployedUrl: '',
    technologies: ['Springboot', 'Spring-security', 'Spring-data', 'Hibernate', 'mysql','React', 'recharts', 'styled-components', 'webpack']
  },{
    title: 'The Wild Oasis',
    description: 'The Wild Oasis is a comprehensive hotel management application built using React. It aims to provide a seamless experience for both hotel administrators and guests by offering features for managing bookings, cabins, guests, and more.',
    repoUrl: 'https://github.com/ksachin7/react-practices/tree/main/the-wild-oasis',
    deployedUrl: 'https://the-wild-oasis-1ef4a.netlify.app',
    technologies: ['React', 'React-query', 'styled-components', 'Supabase', 'recharts', 'webpack']
  }, {
    title: 'Ui Components, Testing & CICD',
    description: 'This project aimed to develop reusable UI components using React and styled-components with support for dark mode. Additionally, unit testing and CI/CD implementation were carried out as part of the project.',
    repoUrl: 'https://github.com/ksachin7/react-practices/tree/main/ui-fundamentals',
    deployedUrl: 'https://elegantwebui.netlify.app',
    technologies: ['React', 'unit-testing', 'styled-components', 'vite', 'jest', 'enzyme', 'cicd']
  }, {
    title: 'Movies',
    description: 'This is a Movie Search App created using React. Users can search for movies, view movie details, rate a movie and add movies to a watchlist. It leverages the OMDb API to fetch movie data.',
    repoUrl: 'https://github.com/ksachin7/react-practices/tree/main/movies',
    deployedUrl: 'https://movies-02bf70.netlify.app',
    technologies: ['React', 'oldb-api', 'styled-components', 'vite']
  }, {
    title: 'Shopping-cart',
    description: 'The Shopping Cart App is a React application that allows users to view a list of products, add them to the shopping cart, and manage the cart contents. The app utilizes Redux for state management and provides a clean and structured way to handle complex application states.',
    repoUrl: 'https://github.com/ksachin7/react-practices/tree/main/shopping-cart',
    deployedUrl: '',
    technologies: ['React', 'Redux', 'styled-components']
  }]

  const certifications = [
    '/Achievements/UC-26c84804-fd70-4e97-aa02-9d69ad45e13d.jpeg',
    '/Achievements/UC-2fc4591b-f68b-414e-a377-c987be3bd323.jpeg',
    '/Achievements/220350320116.jpg',
    '/Achievements/CSS.png',
    '/Achievements/Java (Basic) Certificate.png',
    '/Achievements/JavaScript.png',
    '/Achievements/CertificateOfCompletion_JavaScript Essential Training.jpg',
    '/Achievements/Coursera 2AFLY7547DW2.jpg',
    '/Achievements/Coursera 7NSRWGQW5CKP.jpg',
    '/Achievements/Coursera AY6E6LDGMLZA.jpg',
    '/Achievements/Coursera L8MPASUZ9Z3U.jpg',
    '/Achievements/Coursera NB9ENEXX8CPU.jpg',
    '/Achievements/Coursera PFQDRUGNGQWJ.jpg',
    '/Achievements/Barclays Certificate7549577285513860947.jpg',
    '/Achievements/Certificate for Sachin Kumar for "PVPIT Webinar- Data Science...".jpg',
    '/Achievements/Learn With Me - IST.jpg',
    '/Achievements/Sachin_Kumar_Hired_Certificate.jpg',
  ];
  return (
    <SectionWrapper>
      <Title>Projects & Certificates</Title>
      <Content
        active={activeTab === 'projects'}>
        <SubTitle>Developing projects enables you to utilize your skills, enhance your comprehension, and demonstrate your capabilities. Here are the projects I've recently done. <StyledSpan>Click on the github button to see more details of the project.</StyledSpan></SubTitle>
        <ProjectList>
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              description={project.description}
              repoUrl={project.repoUrl}
              deployedUrl={project.deployedUrl}
              // deploymentStatus={project.deploymentStatus}
              technologies={project.technologies}
            />
          ))}
        </ProjectList>
      </Content>
      <Content active={activeTab === 'certificates'}>
        <ImageGallery images={certifications} />
        {/* <CertsWrap>
        {certifications.map(cert =>
            <Certs src={cert} />
        )}
        </CertsWrap> */}
        {/* <Certification certifications={certifications} /> */}
      </Content>
      <Tabs>
        <TabButton
          onClick={() => handleTabChange('projects')}
          active={activeTab === 'projects'}
        >
          Projects
        </TabButton>
        <TabButton
          onClick={() => handleTabChange('certificates')}
          active={activeTab === 'certificates'}
        >
          Certificates
        </TabButton>
      </Tabs>
    </SectionWrapper>
  );
};

export default ProjectsSection;
